import { useQuery } from '@tanstack/react-query';
import financialTransactionsApi from '@/features/dashboard/financialTransactions/api/financialTransactionsApi.ts';
import { financialTransactionsApiQueryKeys } from '@/features/dashboard/financialTransactions/api/financialTransactionsApi.queryKeys.ts';

const useGetFinancialTransaction = (transactionId: string) => {
  return useQuery({
    queryKey: financialTransactionsApiQueryKeys.byId(transactionId),
    queryFn: () => financialTransactionsApi.getById(transactionId),
    enabled: !!transactionId,
  });
};

export default useGetFinancialTransaction;
